import { render, staticRenderFns } from "./updatePayment.vue?vue&type=template&id=3e45d0c3&"
import script from "./updatePayment.vue?vue&type=script&lang=ts&"
export * from "./updatePayment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports